import React from 'react'
import ReactHTMLParser from 'react-html-parser'
import Footer from '../Home/Footer'

export default (props) => (
  <div style={props.style}>
    <header className="l-header l-header-lower recruit-header">
      <div className="header-bg" />
      <div className="header-wrap">
        <div className="header-return"><a onClick={props.backToHome} >
            <svg className="svgIllust" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <title />
              <path d="M333.653,41.349H48.769c-7.187,0-13.031,5.848-13.031,13.027v62.129c0,7.184,5.844,13.028,13.031,13.028h286.223c45.484,0,84.328,34.156,88.43,77.758c2.313,24.539-5.516,48.051-22.039,66.199c-16.305,17.918-39.508,28.191-63.645,28.191H199.769V230.76c0-5.386-4.382-9.77-9.774-9.77c-1.859,0-3.683,0.531-5.25,1.539L4.523,337.525C1.695,339.322,0.004,342.4,0,345.752c-0.004,3.352,1.684,6.434,4.512,8.242L184.75,469.119c1.574,1.004,3.39,1.532,5.246,1.532c5.391,0,9.774-4.383,9.774-9.77v-71.016h137.969c47.727,0,92.294-18.988,125.489-53.465c33.176-34.45,50.449-79.73,48.645-127.504C508.379,116.509,428.43,41.349,333.653,41.349z" />
            </svg></a></div>
        {/* <nav className="header-nav">
          <ul>
            <li className="entry"><a target="_blank" href={props.formUrl} rel="noopener noreferrer">ENTRY</a></li>
          </ul>
        </nav> */}
      </div>
    </header>
    <main className="l-main theme-single">
      <article className="l-article">
        <section className="recruitments_lower">
          <div className="recruitments_lower_first">
            <div className="visual">
              <img src={`images/recruitments/${props.data.first.visual}.webp`} alt="" />
            </div>
            <div className="text_group">
              <div className="group">
                <h3>{props.data.jobName}</h3>
                <p className="subtitle">{props.data.first.catch}</p>
                <p className="text">{ReactHTMLParser(props.data.first.read)}</p>
                <div className="pagelinks">
                  {props.data.new &&
                  <div className="link_left"><a onClick={props.toFreshGraduate}>新卒採用</a></div>
                  }
                  {props.data.mid &&
                  <div className="link_right"><a onClick={props.toMidCareer}>中途採用</a></div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="recruitments_lower_second">
            <div className="recruitments_lower_wrapper">
              {props.data.new &&
              <React.Fragment>
                <div className="group" id="new">
                  <p className="group_title">新卒採用</p>
                  {!props.data.new.recruiting &&
                  <React.Fragment>
                    <p>現在、募集を行っておりません。</p>
                  </React.Fragment>
                  }
                  {props.data.new.recruiting &&
                  <React.Fragment>
                    <dl className="info">
                      <dt>雇用形態</dt>
                      <dd>正社員</dd>
                      <dt>募集職種</dt>
                      <dd>{props.data.jobName}</dd>
                      <dt>仕事内容</dt>
                      <dd>{ReactHTMLParser(props.data.new.work)}</dd>
                      <dt>開発環境</dt>
                      <dd>{ReactHTMLParser(props.data.new.develop)}</dd>
                      <dt>給与</dt>
                      <dd>{ReactHTMLParser(props.data.new.salary)}</dd>
                      {props.data.new.qualification &&
                      <React.Fragment>
                        <dt>応募資格</dt>
                        <dd>{ReactHTMLParser(props.data.new.qualification)}</dd>
                      </React.Fragment>
                      }
                      <dt>勤務時間</dt>
                      <dd>{ReactHTMLParser(props.data.new.time)}</dd>
                      <dt>勤務地</dt>
                      <dd>東京都文京区湯島1-6-3 湯島1丁目ビル4階・6階<br />【アクセス】<br />JR各線、東京メトロ丸ノ内線「御茶ノ水駅」より徒歩7分<br />東京メトロ千代田線「新御茶ノ水駅より」徒歩11分<br />東京メトロ丸ノ内線・大江戸線「本郷三丁目駅」より徒歩8分</dd>
                    </dl>
                    <div className="flows">
                      <div className="flows_title">
                        <p className="title">新卒採用の選考フロー</p>
                      </div>
                      <div className="flows_contents">
                        <div className="item">
                          <div className="box">
                            <p className="step">STEP<span>1</span></p>
                            <p className="text">会社説明動画の視聴</p>
                          </div>
                        </div>
                        <div className="item">
                          <div className="box">
                            <p className="step">STEP<span>2</span></p>
                            <p className="text">一次選考（履歴書・選考シート提出、適性検査）</p>
                          </div>
                        </div>
                        <div className="item">
                          <div className="box">
                            <p className="step">STEP<span>3</span></p>
                            <p className="text">二次選考（能力テスト、現場社員面接）</p>
                          </div>
                        </div>
                        <div className="item">
                          <div className="box">
                            <p className="step">STEP<span>4</span></p>
                            <p className="text">最終選考（社長面接）</p>
                          </div>
                        </div>
                        <div className="item">
                          <div className="box">
                            <p className="step">STEP<span>5</span></p>
                            <p className="text">内定</p>
                          </div>
                        </div>
                      </div>
                      <div className="flows_sup">
                        <ul>
                          <li>ご応募から内定までは2ヶ月程度とお考えください。</li>
                          <li>※デザイナー志望者は、STEP2にポートフォリオ審査が加わります。</li>
                          <li>※面接日等は考慮しますので、ご相談ください。</li>
                        </ul>
                      </div>
                    </div>
                    <div className="entry_link">
                      <p className="title">新卒採用にご応募の方はこちら</p>
                      <a className="mainavi_link" href="https://job.mynavi.jp/25/pc/search/corp92309/outline.html" target="_blank" rel="noopener noreferrer">
                        <img src="images/common/mainavi.webp" alt="マイナビ2025" />
                      </a>
                      <a className="mainavi_link" href="https://job.rikunabi.com/2025/company/r620230017/" target="_blank" rel="noopener noreferrer">
                        <img src="images/common/rikunavi.webp" alt="リクナビ2025" />
                      </a>
                    </div>
                  </React.Fragment>
                }
                </div>
              </React.Fragment>
              }
              {props.data.mid &&
              <React.Fragment>
              <div className="group" id="mid">
                <p className="group_title">中途採用</p>
                {!props.data.mid.recruiting &&
                <React.Fragment>
                  <p>現在、募集を行っておりません。</p>
                </React.Fragment>
                }
                {props.data.mid.recruiting &&
                <React.Fragment>
                  <dl className="info">
                    <dt>雇用形態</dt>
                    <dd>正社員</dd>
                    <dt>募集職種</dt>
                    <dd>{props.data.jobName}</dd>
                    <dt>仕事内容</dt>
                    <dd>{ReactHTMLParser(props.data.mid.work)}</dd>
                    <dt>開発環境</dt>
                    <dd>{ReactHTMLParser(props.data.mid.develop)}</dd>
                    <dt>給与</dt>
                    <dd>{ReactHTMLParser(props.data.mid.salary)}</dd>
                    <dt>応募資格</dt>
                    <dd>{ReactHTMLParser(props.data.mid.qualification)}</dd>
                    <dt>勤務時間</dt>
                    <dd>{ReactHTMLParser(props.data.mid.time)}</dd>
                    <dt>勤務地</dt>
                    <dd>東京都文京区湯島1-6-3 湯島1丁目ビル4階・6階<br />【アクセス】<br />JR各線、東京メトロ丸ノ内線「御茶ノ水駅」より徒歩7分<br />東京メトロ千代田線「新御茶ノ水駅より」徒歩11分<br />東京メトロ丸ノ内線・大江戸線「本郷三丁目駅」より徒歩8分</dd>
                  </dl>
                  <div className="flows">
                    <div className="flows_title">
                      <p className="title">中途採用の選考フロー</p>
                    </div>
                    <div className="flows_contents flows_mid">
                      <div className="item">
                        <div className="box">
                          <p className="step">STEP<span>1</span></p>
                          <p className="text">書類選考</p>
                        </div>
                      </div>
                      <div className="item">
                        <div className="box">
                          <p className="step">STEP<span>2</span></p>
                          <p className="text">一次選考（一次面接、Webテスト）</p>
                        </div>
                      </div>
                      <div className="item">
                        <div className="box">
                          <p className="step">STEP<span>3</span></p>
                          <p className="text">最終選考（社長面接）</p>
                        </div>
                      </div>
                      <div className="item">
                        <div className="box">
                          <p className="step">STEP<span>4</span></p>
                          <p className="text">内定</p>
                        </div>
                      </div>
                    </div>
                    <div className="flows_sup">
                      <ul>
                        <li>※選考は迅速に行います。</li>
                        <li>※面接日等は考慮しますので、ご相談ください。</li>
                      </ul>
                    </div>
                  </div>
                  <div className="entry_link">
                    <p className="title">中途採用にご応募の方はこちら</p><a className="entry_btn" target="_blank" href={props.formUrl} rel="noopener noreferrer">ENTRY</a>
                  </div>
                </React.Fragment>
                }
              </div>
              </React.Fragment>
              }
            </div>
            <div className="recruitments_lower_return">
              <div className="return"><a onClick={props.backToHome} >
                  <svg className="svgIllust" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <title />
                    <path d="M333.653,41.349H48.769c-7.187,0-13.031,5.848-13.031,13.027v62.129c0,7.184,5.844,13.028,13.031,13.028h286.223c45.484,0,84.328,34.156,88.43,77.758c2.313,24.539-5.516,48.051-22.039,66.199c-16.305,17.918-39.508,28.191-63.645,28.191H199.769V230.76c0-5.386-4.382-9.77-9.774-9.77c-1.859,0-3.683,0.531-5.25,1.539L4.523,337.525C1.695,339.322,0.004,342.4,0,345.752c-0.004,3.352,1.684,6.434,4.512,8.242L184.75,469.119c1.574,1.004,3.39,1.532,5.246,1.532c5.391,0,9.774-4.383,9.774-9.77v-71.016h137.969c47.727,0,92.294-18.988,125.489-53.465c33.176-34.45,50.449-79.73,48.645-127.504C508.379,116.509,428.43,41.349,333.653,41.349z" />
                  </svg></a></div>
            </div>
          </div>
        </section>
      </article>
    </main>
    <Footer isModalFooter={true} />
  </div>
)


// WEBPACK FOOTER //
// ./src/Recruit/Container.js